/*window.onpopstate = function(event) {
  location.reload();   
}*/

$(window).on("load", function () {
	$('.lm-cart-slider').each(function (key, item) {
		var id = $(this).attr('id');
		$("#" + id).slick({
			prevArrow: "",
			nextArrow: "",
			infinite: true,
			lazyLoad: 'ondemand',
			dots: true,
			autoplay: true,
            cssEase: 'ease-in-out',
			pauseOnHover: false,
          	pauseOnFocus: false,
          	prevArrow: "<a href='#' class='previos'><i class='fas fa-chevron-left'></i></a>",
			nextArrow: "<a href='#' class='next'><i class='fas fa-chevron-right'></i></a>",
		});
	});
  	$(document).on('click', '.lm-cart-slider', function () {
      $(this).slick('slickNext');
    });
  
  	
  	
});
$
$(document).ready(function () { 
  	/*var tsTimer = setInterval(function(){
      var exist =  $("#trustbadge-topbar-container-98e3dadd90eb493088abdc5597a70810").length > 0 || $('#trustbadge-container-98e3dadd90eb493088abdc5597a70810').length > 0;      
      if (exist){ 
        clearInterval(tsTimer);
        $("#trustbadge-topbar-container-98e3dadd90eb493088abdc5597a70810").detach().appendTo(".lm-cart-tr").attr('style', 'display: block !important');   
      }
  	}, 500);*/
  
  	$(document).on('click', 'a.site-header__logo-link', function (e) {
      //e.preventDefault();
      //window.location.href= '/collections/all';
    });
  
  	
	/*$(document).on('click', '.cart__checkout', function (e) {
		$('#lm-loading-screen h1').text('Wir bringen dich sicher zur Kasse...');
		$('#lm-loading-screen').fadeIn(350);
	});*/
  
  	/*$(document).on('click', '.lm-cart-edit', function (e) {
      var href= $(this).attr('href');
      var lineItem = $(this).data('line-item');
      
      $('#lm-loading-screen h1').text('Gleich kannst du deine Leinwand bearbeiten...');
	  $('#lm-loading-screen').fadeIn(350);
      $.get("/cart/change?line=" + lineItem + "&quantity=0", function (data) {
			window.location = href;
		});

      return false;
	})*/
  
  	$('.lm-cart-personalisierung-toggle').click(function(){
      var body = $(this).next('.lm-cart-personlisierung');
      var text = $(this).children('span');
      var icon = $(this).children('i');
      var active = body.hasClass('active');
      if(active) {
      	body.removeClass('active');
        text.text('Personalisierung öffnen');
        icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        body.slideUp(250);
      } else {
      	body.addClass('active');	
        text.text('Personalisierung schließen');
        icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
        body.slideDown(250);
      }
    });
	$(".lm-review-slider").slick({	
		prevArrow: "<a href='#' class='previos'><svg style='transform: rotate(180deg);' xmlns='http://www.w3.org/2000/svg' width='10' height='15' viewBox='0 0 18 34'><path d='M335.178,280.452l16.5,16.5-16.5,16.5' transform='translate(-334.471 -279.745)' fill='none' stroke='#262626' stroke-width='5'></path></svg></a>",
		nextArrow: "<a href='#' class='next'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='15' viewBox='0 0 18 34'><path d='M335.178,280.452l16.5,16.5-16.5,16.5' transform='translate(-334.471 -279.745)' fill='none' stroke='#262626' stroke-width='5'></path></svg></a>",
		slidesToScroll: 2,
      	slidesToShow: 3,
		infinite: true,
		dots: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
               	slidesToShow: 1,
        		slidesToScroll: 1,       
            }
          } 
        ]
	});
  	$(document).on('click', '.lm-review-slider', function () {
      $(this).slick('slickNext');
    });
  
	$('.lm-cart-amount select').on('change', function (e) {
		$('#lm-loading-screen h1').text('Deine Menge wird geändert...');
		$('#lm-loading-screen').fadeIn(250);
      	var quantity = $(this).val();
		$.get('https://leinwandmomente.deseyve.com/personalize.php?type=changed_quantity_in_cart_to_'+quantity);		
		var lineItem = $(this).data('quantity-item');
		$.get("/cart/change?line=" + lineItem + "&quantity=" + quantity, function (data) {
			window.location.href = "/cart";
		});
	});
	//init countdown
	/*var countdownString = localStorage.getItem('lm-countdown');
	$('.lm-countdown').fadeIn();
	if (countdownString == null) {
		var countDownDate = new Date();
		countDownDate.setMinutes(countDownDate.getMinutes() + 3);
		localStorage.setItem('lm-countdown', countDownDate.toString());
	} else {
		var now = new Date();
		var countDownDate = Date.parse(countdownString);
		if (now >= countDownDate) {
			var countDownDate = new Date();
			countDownDate.setMinutes(countDownDate.getMinutes() + 3);
			localStorage.setItem('lm-countdown', countDownDate.toString());
		}
	}
	var x = setInterval(function () {
		countdownTick(countDownDate, x);
	}, 500);
	countdownTick(countDownDate, x);*/
});

function countdownTick(pCountdownDate, pInterval) {
	var now = new Date().getTime();
	var distance = pCountdownDate - now;
	var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	var seconds = Math.floor((distance % (1000 * 60)) / 1000);
	if (seconds < 10) {
		seconds = "0" + seconds;
	}
	if (distance <= 0) {
		clearInterval(pInterval);
		$('.lm-countdown').html("Dein Warenkorb ist leider nicht mehr <b>reserviert!</b>");
	} else {
		$('.lm-countdown').html("Nur noch <b>3 reduzierte Leinwände verfügbar!</b><br>Dein Warenkorb wird für die nächsten <b>" + minutes + ":" + seconds + " Minuten</b> reserviert.");
	}
	/*if (distance <= 0) {
                clearInterval(cd);
                cd.innerHTML = "Dein Warenkorb ist leider nicht mehr <b>reserviert!</b>.";
              } else {
                cd.innerHTML = "<b>Nur noch 2 Leinwände verfügbar!</b> Dein Warenkorb wird für die nächsten <b>" + minutes + ":" + seconds + " Minuten</b> reserviert.";
              }*/
}

function selectChanged(pLineNumber, pNewVariant) {
	$('#lm-loading-screen h1').text('Deine Größe wird geändert...');
	$('#lm-loading-screen').fadeIn(250);
	var quantity = $('.lm-cart li.lm-cart-item').eq(pLineNumber - 1).find('.lm-cart-amount input').val()
	jQuery.getJSON('/cart.js', function (cart) {
		var line_item = pLineNumber;
		var newVariantID = pNewVariant;
		var properties = cart.items[line_item - 1].properties;
		//Delete old product
		$.get("/cart/change?line=" + line_item + "&quantity=0", function (data) {
			//add new variant
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: {
					quantity: quantity,
					id: newVariantID,
					properties: properties
				},
			}).done(function () {
				window.location.reload(1);
			});;
		});
	});
}